
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"26","height":"24","viewBox":"0 0 26 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"a","x1":".192","y1":".208","x2":"1","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#ee7c21"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#cb2222"}})])]),_c('path',{attrs:{"data-name":"Union 2","d":"M11.556 30.556l2.6-3h6.8l2.6 3zm-7-5v-19h26v19zm15.2-7.731c-.914 1.728.976 2.139 3.005 2.608 1.822.421 1.882 1.327 1.876 2.913v.211h3.918v-15h-22v15h3.918v-.229c-.006-1.575.061-2.476 1.876-2.9 1.987-.459 3.948-.869 3.005-2.608-2.793-5.153-.8-8.075 2.2-8.075 2.946.004 4.992 2.818 2.205 8.079z","transform":"translate(-4.556 -6.556)","fill":"url(#a)"}})])
          )
        }
      }
    